// extracted by mini-css-extract-plugin
export default {"border":"border--vE_ld","badge":"badge--FSqcH"};